// src/components/shared/ChartToggle.js
import React from 'react';

const ChartToggle = ({
  cumulativeView,
  onToggle,
  label = "Weergave"
}) => {
  return (
    <div className="toggle-wrapper">
      <span className="toggle-label">{label}:</span>
      <label className="cursor-pointer">
        <input
          type="checkbox"
          checked={cumulativeView}
          onChange={(e) => onToggle(e.target.checked)}
          className="sr-only"
        />
        <div className={`toggle-switch ${cumulativeView ? 'active' : ''}`}>
          <span className="toggle-knob" />
        </div>
      </label>
      <span className="toggle-value">
        {cumulativeView ? 'Cumulatief' : 'Dagelijks'}
      </span>
    </div>
  );
};

export default ChartToggle;
